"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EidlCollateral = exports.EidlLoanType = void 0;
var EidlLoanType;
(function (EidlLoanType) {
    EidlLoanType["CREDIT"] = "Line of Credit";
    EidlLoanType["EIDL"] = "EIDL";
    EidlLoanType["TERM"] = "Term Loan";
})(EidlLoanType = exports.EidlLoanType || (exports.EidlLoanType = {}));
var EidlCollateral;
(function (EidlCollateral) {
    EidlCollateral["ALL_BUSINESS_ASSETS"] = "All Business Assets";
    EidlCollateral["EQUIPMENT"] = "Equipment";
    EidlCollateral["REAL_ESTATE"] = "Real Estate";
    EidlCollateral["OTHER"] = "Other";
})(EidlCollateral = exports.EidlCollateral || (exports.EidlCollateral = {}));
